/*
====================================================

AI Product Builder

负责:

- Size Card生成
- Size UI状态
- Frame addon提示


Shopify同步:

交给

AI_VARIANT_MANAGER


====================================================
*/


(function(){


"use strict";



let currentVariantState = null;





function initAIProductBuilder(){


    const container =
    document.querySelector(
        "#ai-size-selector"
    );



    if(!container){

        return;

    }



    const config =
    window.AI_PRODUCT_BUILDER_CONFIG
    ?.get(
        window.CURRENT_SKU_SIZE
    );



    if(!config){

        return;

    }



    const sizes =
    getAvailableSizes();



    renderSizeCards(
        sizes,
        config,
        container
    );



    bindVariantEvents();



}








function getAvailableSizes(){


    const result =
    new Set();



    (
        window.productVariantsJSON || []
    )
    .forEach(
        variant=>{


            if(variant.option2){


                result.add(
                    normalizeSize(
                        variant.option2
                    )
                );


            }


        }
    );



    return [
        ...result
    ];

}



function normalizeSize(value){


    return value
    .toLowerCase()
    .replace(/\s+/g,"")
    .replace("×","x");


}








function renderSizeCards(
sizes,
config,
container
){


    container.innerHTML="";



    sizes.forEach(
        size=>{


            const item =
            config.values[size];



            if(!item){

                return;

            }



            container.appendChild(
                createCard(
                    size,
                    item
                )
            );


        }
    );


}







function createCard(
size,
item
){


    const card =
    document.createElement(
        "div"
    );



    card.className =
    "ai-size-card";



    card.dataset.size =
    size;



    card.innerHTML=`

<div class="ai-size-radio"></div>


<div class="ai-size-content">


<div class="ai-size-title">

${item.icon || ""}

${item.title}

</div>


<div class="ai-size-label">

${item.sizeLabel}

</div>


</div>



<div class="ai-size-price">


<div class="ai-current-price">

$${item.displayPrice}

</div>



<div class="ai-price-bottom">

<span class="ai-compare-price">

$${item.comparePrice}

</span>


<span class="ai-discount">

-${discount(
item.displayPrice,
item.comparePrice
)}%

</span>


</div>



<div class="ai-frame-addon-info"></div>



</div>

`;




if(item.badge){


const badge =
document.createElement(
"div"
);


badge.className =
"ai-size-badge";


badge.innerHTML =
"🎁 "+item.badge;


card.appendChild(
badge
);


}





card.onclick=()=>{


if(window.AI_VARIANT_MANAGER){


AI_VARIANT_MANAGER.select({

option2:size

});


}



};



return card;


}








function bindVariantEvents(){



window.addEventListener(
"ai:variant-init",
e=>{


    applyVariantState(
        e.detail
    );


}
);





window.addEventListener(
"ai:variant-change",
e=>{


    applyVariantState(
        e.detail
    );


}
);



}








function applyVariantState(detail){


const {
variant,
state
}
=
detail;



currentVariantState =
state;



const size =
normalizeSize(
state.option2
);



document
.querySelectorAll(
".ai-size-card"
)
.forEach(
card=>{


card.classList.remove(
"active"
);



if(
card.dataset.size===size
){

card.classList.add(
"active"
);


}



}
);





updateFrameAddon(
variant
);



}









function updateFrameAddon(
variant
){



document
.querySelectorAll(
".ai-frame-addon-info"
)
.forEach(
el=>{

el.innerHTML="";

}
);



if(!variant){

return;

}





if(
variant.option1==="Canvas Only"
){

return;

}





const size =
normalizeSize(
variant.option2
);



const config =
window.AI_PRODUCT_BUILDER_CONFIG
.get(
window.CURRENT_SKU_SIZE
);



const text =
config
.values[size]
?.addons
?.frame
?.text;



const active =
document.querySelector(
".ai-size-card.active"
);



const target =
active?.querySelector(
".ai-frame-addon-info"
);



if(target && text){


target.innerHTML =
text;


}



}








function discount(
price,
compare
){


return Math.round(
(
1-
parseFloat(price)/
parseFloat(compare)
)
*100
);


}






document.addEventListener(
"DOMContentLoaded",
initAIProductBuilder
);



})();